module.exports = "<div #content class=\"app-modal-container-wrapper\">\n  <div *ngIf=\"depositData\" >\n    <receipt-page-submit-receipt-modal  (modalAction)=\"modalActionsHandler($event)\"\n                                        [modalDepositInput]=\"depositData\"></receipt-page-submit-receipt-modal>\n  </div>\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/receipt/receipt-page-submit-receipt-modal-container/receipt-page-submit-receipt-modal-container.component.html
// module id = ./src/app/admin/receipt/receipt-page-submit-receipt-modal-container/receipt-page-submit-receipt-modal-container.component.html
// module chunks = main